import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

function OpalTile ({ children, className, style, size }) {
  const cn = `opal-tile${size ? `-${size}` : ''}`
  return (
    <div className={clsx(className, cn)} style={style}>
      {children}
    </div>
  )
}

OpalTile.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])])
}

export default OpalTile
